import React, { useEffect, useState } from "react";
import owner from "../../asstes/owner.jpg";
import {
  FaArrowUp,
  FaChevronDown,
  FaCopy,
  FaLongArrowAltUp,
} from "react-icons/fa";
import { ImNotification } from "react-icons/im";
import frgImg from "../../asstes/frgx.webp";
import icon from "../../asstes/activity_white.webp";
import cup from "../../asstes/cup.svg";
import RecentPlatfrom from "./RecentPlatfrom";
import MembersTotalBox from "./MembersTotalBox";
import { MdAppRegistration, MdDashboard } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { FaAngleDown } from "react-icons/fa6";
import { AiOutlineTeam } from "react-icons/ai";
import {
  FaTelegramPlane,
  FaTwitter,
  FaInstagramSquare,
  FaYoutube,
} from "react-icons/fa";
import Forsagex3Page from "./Forsagex3Page";
import Forsagex3Details from "./Forsagex3Details";
import { useSelector } from "react-redux";
import UnknownUser from "../../asstes/UnknownUser.webp";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setUserActivy, setshowcomponents } from "../Store/userslice";
import Partners from "../Partners/Partners";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DashBoard = () => {
  //----Redux States------
  const dispatch = useDispatch();
  const userdata = useSelector((state) => state.user.UserData);
  const showcomponents = useSelector((state) => state.user.showcomponents);
  // const userAddress = userdata?.user?.userAddress;
  const userReferralCode = userdata?.user?.userReferralCode;
  // const ReferalLink = `https://myreview.website/WebTech/register?userReferralCode=${userReferralCode}`;

  // const baseUrl = "http://localhost:3000/WebTech/Register/userReferralCode=";
  const baseUrl = "https://myreview.website/GainApex/Register/userReferralCode=";
  const ReferalLink = baseUrl + userReferralCode;
  const shortLink = `http://short.link/${userReferralCode}`;

  //---------States-------
  const [show, setShow] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleHide = () => {
    setShow(!show);
  };
  const handleIsopen = () => {
    setIsOpen(!isOpen);
  };
  //----Copy Function-----
  const handleCopy = () => {
    const textToCopy = ReferalLink;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1000);
        })
        .catch((err) => console.error("Could not copy text: ", err));
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    }
  };
  //----------- sort address-----------
  const address = userdata?.user?.userAddress;
  const formattedAddress = address
    ? `${address.substring(0, 6)}...${address.substring(address.length - 4)}`
    : "..";
  //--------------
  const timestamp = userdata?.user?.time;
  const date = new Date(timestamp * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  const formattedProfit = userdata?.user?.profit?.toFixed(4);
  const apiUrl = process.env.REACT_APP_API;
  const handelget = async () => {
    try {
      const response = await axios.get(`${apiUrl}/users/new-activity`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(setUserActivy(response.data));
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    handelget();
  }, []);

  //-----Naviget Function-----
  const handleDeshbord = () => {
    dispatch(setshowcomponents(0));
  };
  const navigat = useNavigate();
  const Registration = () => {
    navigat("/register");
  };
  //-------copy Id Funtion---------
  const handleCopyId = (e) => {
    navigator.clipboard.writeText(e).then(
      () => {
        toast("Copied to clipboard!", {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      },
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
  };
  return (
    <>
     
      <ToastContainer />
      <div className="w-full">
        <div className="flex bg-[#222]">
          <aside
            className="h-screen bg-[#222] fixed w-[25%] lg:sticky top-0 border-r-[1px] border-slate-700  pt-20 whitespace-nowrap  lg:block hidden   shadow-xl "
            id="background"
          >
            <div className="px-8 pt-5">
              <section 
              // className=" brightness-125 py-2 mt-5 mb-5 dashboard-sidebar-section px-2 shadow rounded-xl flex flex-col "
              className={`${showcomponents===0?"brightness-125 py-2 px-6  text-white dashboard-sidebar-section  shadow rounded-xl flex flex-col":"brightness-125 py-2 px-6  text-white shadow rounded-xl flex flex-col dashboard-sidebar-section-inactive"}`}
              >
                <p
                  className="flex gap-3 items-center text-white cursor-pointer"
                  onClick={handleDeshbord}
                >
                  <span>
                    <MdDashboard size={20} />
                  </span>
                  <span>DashBoard</span>
                </p>
              </section>
              <section className=" brightness-125 py-2 mt-5 mb-5  px-2 shadow rounded-xl dashboard-sidebar-section-inactive flex flex-col ">
                <p
                  className="flex gap-3 items-center text-white cursor-pointer"
                  onClick={Registration}
                >
                  <span>
                    <MdAppRegistration size={20} />
                  </span>
                  <span>Registration</span>
                </p>
              </section>

              <div className="">
                <section className=" py-2   mb-5 px-2 shadow rounded-xl flex flex-col ">
                  <ul className="flex gap-20  items-center justify-between text-white">
                    <li className="flex gap-2  items-center">
                      <span>
                        <RiTeamFill size={20} />
                      </span>
                      <span>Teams</span>
                    </li>
                    <li className=" cursor-pointer" onClick={handleIsopen}>
                      <FaAngleDown size={15} />
                    </li>
                  </ul>
                </section>
                {/* {isOpen ? ( */}
                <section
                  // className="brightness-125 py-2 px-6  text-white dashboard-sidebar-section  shadow rounded-xl flex flex-col"
                  className={`${showcomponents===2 ?"brightness-125 py-2 px-6  text-white dashboard-sidebar-section  shadow rounded-xl flex flex-col":"brightness-125 py-2 px-6  text-white dashboard-sidebar-section-inactive  shadow rounded-xl flex flex-col"}`}
                >
                  <p
                    className="flex cursor-pointer gap-3 items-center "
                    onClick={() => dispatch(setshowcomponents(2))}
                  >
                    <span>
                      <AiOutlineTeam size={20} />
                    </span>
                    <span>Partners</span>
                  </p>
                  {/* <p className="flex cursor-pointer gap-3 items-center ">
                    <span>
                      <MdTransferWithinAStation size={20} />
                    </span>
                    <span>Links</span>
                  </p>
                  <p className="flex cursor-pointer gap-3 items-center ">
                    <span>
                      <AiFillSlackCircle size={20} />
                    </span>
                    <span>Stats</span>
                  </p> */}
                </section>
                {/* // ) : (
                //   ""
                // )} */}
              </div>
            </div>
            <div className="px-8 fixed bottom-4">
              <div className="flex items-center text-white mx-auto gap-4">
                <p className=" rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700">
                  <FaTelegramPlane />
                </p>
                <p className=" rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700">
                  <FaTwitter />
                </p>
                <p className=" rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700">
                  <FaInstagramSquare />
                </p>
                <p className=" rounded-full p-2 cursor-pointer bg-gray-600 hover:bg-gray-700">
                  <FaYoutube />
                </p>
              </div>
            </div>
          </aside>

          {showcomponents === 0 ? (
            <div className="w-full " id="background">
              <main
                className="px-6 py-24 pb-5 lg:px-8 bg-[#222] flex flex-col gap-6 "
                id="background"
              >
                <div className="md:grid md:grid-cols-2 lg:grid lg:grid-cols-2  user-detail-div-dashboard">
                  <section className="  px-2 shadow rounded flex flex-col gap-10">
                    <div className="flex gap-6 items-start">
                      <div className="p-1 rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 user-profile-div-dashboard">
                        {/* <img
                          className=" object-cover w-28 rounded-full "
                          src={userdata?.user?.photo}
                          alt="unknowImg"
                        /> */}
                        {userdata?.user?.photo ? (
                          <img
                            className=" object-cover w-28 rounded-full "
                            src={userdata?.user?.photo}
                            alt="unknowImg"
                          />
                        ) : (
                          <img
                            className=" object-cover w-28 rounded-full "
                            src={UnknownUser}
                            alt="unknowImg"
                          />
                        )}
                        <p className="text-white text-xl userid-dashboard">
                          {userdata?.user?.userId}
                        </p>
                      </div>
                      <div className="w-full flex flex-col items-start gap-3">
                        {userdata?.user?.email ? (
                          <p className="user-detail-text">
                            {userdata?.user?.email}
                          </p>
                        ) : (
                          <p className="deshboard-not-found-text">
                            User email not found
                          </p>
                        )}
                        {userdata?.user?.name ? (
                          <p className="user-detail-text">
                            {userdata?.user?.name}
                          </p>
                        ) : (
                          <p className="deshboard-not-found-text">
                            User name not found
                          </p>
                        )}

                        {/* <p className="text-white text-xl user-id-dashboard">
                            ID {userdata?.user?.userId}
                          </p> */}

                        {/* <p className="text-blue-600 font-medium text-xl">
                          ID {userdata?.user?.userId}
                        </p> */}
                        <div className="text-white hidden md:block lg:block">
                          <p className="flex gap-2">
                            {formattedAddress}
                            <span className="partners-table-copy-icon">
                              <FaCopy
                                size={20}
                                onClick={() =>
                                  handleCopyId(userdata?.user?.userAddress)
                                }
                              />
                            </span>
                          </p>
                          <p
                            // className="text-gray-300 py-2 "
                            className="invited-id-p"
                          >
                            invited {formattedDate} by
                            <span className="invited-id-span">
                              ID {userdata?.user?.referrer_userId}
                              <FaArrowUp className="dashboard-arrow-icon" />
                            </span>
                          </p>
                        </div>
                        <button
                          onClick={handleHide}
                          className="bg-[#444] md:hidden lg:hidden  flex items-center   font-medium w-full text-gray-300 rounded-[20px]  px-10 py-1"
                        >
                          {" "}
                          <span className="ml-12">Show more</span>{" "}
                          <span className="mx-auto">
                            <FaChevronDown size={15} />
                          </span>
                        </button>
                      </div>
                    </div>
                    {/* {show ? (
                      ""
                    ) : (
                      <div className="text-white">
                        <p className="flex gap-2">
                          0xa0A1...eb41{" "}
                          <span className=" cursor-pointer">
                            <FaCopy size={20} />
                          </span>
                        </p>
                        <p className="text-gray-300 py-2 ">
                          invited 24.04.2024 by{" "}
                          <span className=" ml-2 px-4 py-1 cursor-pointer rounded-[15px] bg-[#333] text-blue-600">
                            ID 1
                          </span>
                        </p>
                      </div>
                    )} */}
                  </section>

                  <div className="">
                    <section className="Personal-link Personal-link-div">
                      <div className="flex md:block justify-between items-center px-2">
                        <h1 className=" flex gap-3 items-center">
                          Personal link
                          <span>
                            <ImNotification />
                          </span>
                        </h1>
                        <p className="text-color font-bold text-to-copy copy">
                          {shortLink}
                        </p>
                      </div>
                      <button
                        className="copy-btn navbar-button-color"
                        onClick={handleCopy}
                      >
                        {copied ? "Copied!" : "Copy"}
                      </button>
                    </section>
                    {/* <section className="relative">
                      <img
                        className=" rounded-xl hover:bg-[#333]"
                        src={frgImg}
                        alt="frgImg"
                      />
                      <p className="text-white md:hidden lg:block hidden absolute top-5 left-[45%]">
                        FRGX Token
                      </p>
                    </section> */}
                  </div>
                </div>
                <div className="md:flex md:justify-between md:gap-4 lg:flex lg:justify-between partners-usertem-profit-div lg:gap-4 ">
                  <div className="flex py-4 w-full justify-between items-center gap-3 ">
                    <section className="py-2 w-full rounded-xl px-3 bg-[#333] ratio-section Partners-div">
                      <p className="white-color-dashboard">Partners</p>
                      <p className=" font-bold text-2xl py-3 text-white">
                        {userdata?.user?.partners}
                      </p>
                      <div className="py-2 flex items-center justify-between  rounded-[20px] px-3  ratio-section-inner-div">
                        <p className="flex white-color-dashboard text-sm items-center gap-1">
                          <FaLongArrowAltUp className="Partners-div-icon" />
                          <span className="text-xl">0</span>
                        </p>
                        <img
                          src={icon}
                          alt="icon"
                          className="Partners-div-icon-img"
                        />
                      </div>
                    </section>
                    <section className="py-2  w-full rounded-xl px-3 bg-[#333] ratio-section Partners-div">
                      <p className="white-color-dashboard">User Teams</p>
                      <p className=" font-bold text-2xl py-3 text-white">
                        {userdata?.user?.userTeamCount}
                      </p>
                      <div className="py-2 flex items-center justify-between  rounded-[20px] px-3  ratio-section-inner-div">
                        <p className="flex white-color-dashboard text-sm items-center gap-1">
                          <FaLongArrowAltUp className="Partners-div-icon" />
                          <span className="text-xl">0</span>
                        </p>
                        <img
                          src={icon}
                          alt="icon"
                          className="Partners-div-icon-img"
                        />
                      </div>
                    </section>
                  </div>

                  <section className="py-2 rounded-xl px-3 bg-[#333] ratio-section profit-div Partners-div">
                    <p className="white-color-dashboard py-3">Profits</p>
                    <div className="flex justify-between px-3 text-white items-center ">
                      <p className=" flex gap-2 items-center font-bold text-2xl">
                        {formattedProfit}
                        <span className="font-bold">BUSD</span>
                      </p>
                    </div>
                    <div className="py-2 flex items-center justify-between  rounded-[20px] px-3  ratio-section-inner-div myany">
                      <p className="flex white-color-dashboard text-sm items-center gap-1">
                        <FaLongArrowAltUp className="Partners-div-icon" />
                        <span className="text-xl">0</span>
                      </p>
                      <img
                        src={icon}
                        alt="icon"
                        className="Partners-div-icon-img"
                      />
                    </div>
                  </section>
                </div>
                <section className="py-2 flex justify-between items-center  w-full rounded-xl px-3 bg-[#333] ratio-section Ratio-div">
                  <p className="white-color-dashboard">Ratio</p>
                  <p className="text-white font-bold text-2xl">0 %</p>
                  <div className="py-2 flex w-1/2 items-center justify-between  rounded-[20px] px-3   ration-arrow-div">
                    <p className="flex white-color-dashboard text-sm items-center gap-1">
                      <FaLongArrowAltUp className="Partners-div-icon" />
                      <span className="text-xl">0</span>
                    </p>
                    <img
                      src={icon}
                      alt="icon"
                      className="Partners-div-icon-img ration-arrow-div-img"
                    />
                  </div>
                </section>
              </main>
              {/* <div className="md:px-8 lg:px-10 ">
                <section className="py-2 md:rounded-xl lg:rounded-xl my-5 w-full px:mx-10   bg-[#333]">
                  <div className="flex justify-between md:flex  md:items-center md:justify-between md:px-12 lg:flex  lg:items-center lg:justify-between lg:px-12 mx-auto items-center">
                    <img className="w-24 object-cover" src={cup} alt="" />
                    <img className="w-24 object-cover" src={cup} alt="" />
                    <img className="w-24 object-cover" src={cup} alt="" />
                    <img className="w-24 object-cover" src={cup} alt="" />
                    <p className="text-center hidden md:block lg:block font-bold cursor-pointer text-gray-400">
                      Show all
                    </p>
                  </div>
                  <p className="text-center md:hidden lg:hidden font-bold cursor-pointer text-gray-400">
                    Show all
                  </p>
                </section>
              </div> */}

              {/* --- forsage programs sections start here --- */}
              <div className="flex  items-center gap-3 px-5 py-3">
                <h1 className="text-white font-bold text-2xl">
                  Forsage x3 Programs{" "}
                </h1>
                <span className="text-white px-3 py-1 rounded-[20px] flex gap-2 items-center navbar-button-color ">
                  <ImNotification size={20} />
                  Info
                </span>
              </div>
              <Forsagex3Page />
              <Boxs />
            </div>
          ) : null}
          {showcomponents === 1 ? <Forsagex3Details /> : null}
          {showcomponents === 2 ? <Partners /> : null}
        </div>
      </div>
    </>
  );
};

export default DashBoard;

const Boxs = () => {
  const box = [{ text: "x3", busdText: "0 BUSD" }];
  const data = ["", "", "", "", null, null, null, null, null, null];

  return (
    <>
      <div className="w-full px-2 md:px-5">
        <div className=" md:grid  md:grid-cols-2">
          <div className="md:px-16 lg:px-20">
            <MembersTotalBox />
          </div>
          <div className="order-last lg:order-first md:order-first px-3 md:px-3 my-5   rounded-xl">
            <RecentPlatfrom />
          </div>
        </div>
        <div className="py-10">
          <p className="text-gray-400 text-sm ">© 2024 All Rights Reserved</p>
        </div>
      </div>
    </>
  );
};
